import { api } from '@api'
import { Carrier } from '@types'

export interface Form {
  carrierId: number
  category?: number
  enabledForAlgorithm?: boolean
}

export interface CarrierWithPassword extends Carrier {
  password?: string
}

interface CreateCarrierResponse {
  result: Carrier
}

const createCarrier = async (payload: CarrierWithPassword) => {
  const response = await api.post<CreateCarrierResponse>('/carriers', { carrier: payload })

  return response.data.result
}

export { createCarrier }
